import type { AppThemeTone } from "@/components/editorial/product-bridge/app-surface";

import { ShotFigure } from "./figure";
import { calderWorkspace } from "./fixture-calder";
import { ReplayControls } from "./replay-controls";
import { WORKFLOW, WORKFLOW_RUN, WORKFLOW_TITLE } from "./workflow-run";
import { WorkflowRunIsland } from "./workflow-run-player";
import { ShotWorkflowWindow } from "./workflow-window";

/** The sample workspace with the workflow's page open: its authoring session heads the rail's sessions. */
const WORKSPACE = calderWorkspace({ sessionId: WORKFLOW.sessionId, sessionTitle: WORKFLOW_TITLE });

/** What the frame shows, for everyone: the shot is decorative to assistive technology. */
export const WORKFLOW_RUN_SUMMARY =
  "A sample run in a sample workspace: a services firm tests its weekly aged-receivables workflow. Each step runs in turn on the canvas: it reads the HubSpot companies and the Xero invoices, matches each customer across both, ages each invoice, ranks the customers by balance and checks that the totals reconcile. It ends on the results, each customer's balance by age.";

/**
 * A workflow running in the application's Workflows page: the sample
 * workspace's weekly aged-receivables review open on its canvas, rendered
 * here on the server at rest, then run as a sample once the frame is in
 * view. Each step waits, runs and completes in turn, and the run ends on the
 * Results tab with the customers the receivables answer ranks. The frame is
 * decorative to assistive technology; the summary beneath it says what
 * plays, and the control row pauses and replays it.
 */
export function WorkflowRunShot({ tone = "light" }: { tone?: AppThemeTone } = {}) {
  return (
    <ShotFigure summary={WORKFLOW_RUN_SUMMARY} caption="A weekly aged-receivables workflow, run as a sample, step by step.">
      <WorkflowRunIsland workspace={WORKSPACE} tone={tone}>
        <ShotWorkflowWindow tone={tone} workspace={WORKSPACE} frame={WORKFLOW_RUN.frames[0]!} inert aria-hidden="true" />
        <ReplayControls state="idle" progress={0} />
      </WorkflowRunIsland>
    </ShotFigure>
  );
}
